import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    redirect: 'views',
  },
  {
    path: '/Visitors/ReportShow', //pc端测试报告
    name: 'ReportShow',
    component: () => import('../views/Measurement/Visitors/ReportShow.vue'),
  },

  {
    path: '/Visitors/zReportShow', //pc端测试报告
    name: 'zReportShow',
    component: () => import('../views/Measurement/Visitors/zReportShow.vue'),
  },

  {
    path: '/Visitors/zReportnewShow', //新整体报告
    name: 'zReportnewShow',
    component: () => import('../views/Measurement/Visitors/zReportnewShow.vue'),
  },

  {
    path: '/Visitors/ReportShowApp', //app端测试报告
    name: 'ReportShowApp',
    component: () => import('../views/Measurement/Visitors/ReportShowApp.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
  },
  {
    path:'/LoginTransfer',
    name:'LoginTransfer',
    component:() => import('../views/LoginTransfer.vue')
  },
  {
    path: '/views',
    name: 'views',
    meta: { title: '首页' },
    component: () => import('../views/index.vue'),
    children: [
      {
        path: '/index', //首页
        name: 'index',
        meta: { title: '首页' },
        component: () => import('../views/index/index.vue'),
      },
      {
        path: '/stats', //数据统计
        name: 'stats',
        meta: { title: '预约发布2' },
        component: () => import('../views/stats/index.vue'),
      },
      {
        path: '/release', //数据统计
        name: 'release',
        meta: { title: '测试' },
        component: () => import('../views/stats/release.vue'),
      },
      {
        path: '/Deal', //数据统计
        name: 'Deal',
        meta: { title: '预约处理' },
        component: () => import('../views/stats/Deal.vue'),
      },

      {
        path: '/Set', //系统设置
        name: 'Set',
        meta: { title: '设置' },
        component: () => import('../views/Set/index.vue'),
      },
      {
        path: '/Set/index', //列表展示
        name: 'indexss',
        meta: { title: '权限管理', keepAlive: false },
        component: () => import('../views/Set/index.vue'),
      },

      {
        path: '/Consultant/TheTermScheduling', //排班管理
        name: 'TheTermScheduling',
        meta: { title: '学期管理', keepAlive: false },
        component: () => import('../views/Consultant/TheTermScheduling.vue'),
      },

      {
        path: '/Consultant/ConAddress', //咨询地点管理
        name: 'ConAddress',
        meta: { title: '咨询室管理', keepAlive: false },
        component: () => import('../views/Consultant/ConAddress.vue'),
      },

      {
        path: '/Consultant/Consulting_alternate', //咨询地点管理
        name: 'Consulting_alternate',
        meta: { title: '咨询候补', keepAlive: true },
        component: () => import('../views/Consultant/Consulting_alternate.vue'),
      },

      {
        path: '/Consultant/CalendarLayout', //咨询排班
        name: 'CalendarLayout',
        meta: { title: '咨询排班', keepAlive: true },
        component: () => import('../views/Consultant/CalendarLayout.vue'),
      },

      {
        path: '/Consultant/WorkingSchedule', //心理咨询排班
        name: 'WorkingSchedule',
        meta: { title: '心理咨询排班', keepAlive: false },
        component: () => import('../views/Consultant/WorkingSchedule.vue'),
      },

      {
        path: '/Consultant/ConsultingFiles', //咨询档案
        name: 'ConsultingFiles',
        meta: { title: '咨询档案', keepAlive: false },
        component: () => import('../views/Consultant/ConsultingFiles.vue'),
      }, {
        path: '/Consultant/BatchDelete',//批量删除排班
        name: 'BatchDelete',
        meta: { title: '排班批量处理', keepAlive: true },
        component: () => import('../views/Consultant/BatchDelete.vue'),
      }, {
        path: '/Consultant/HolidayManagement',//假期管理
        name: 'HolidayManagement',
        meta: { title: '假期管理', keepAlive: true },
        component: () => import('../views/Consultant/HolidayManagement.vue'),
      },
      {
        path: '/Set/Set_department', //列表展示
        name: '/Set_department',
        meta: { title: '部门管理', keepAlive: true },
        component: () => import('../views/Set/Set_department.vue'),
      },

      {
        path: '/Crisis/Crisis_archives', //学生档案
        name: '/Crisis_archives',
        meta: { title: '学生档案', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_archives.vue'),
      },

      {
        path: '/Crisis/Crisis_measurement', //心理测评
        name: '/Crisis_measurement',
        meta: { title: '心理测评', keepAlive: true },
        component: () => import('../views/Crisis/Crisis_measurement.vue'),
      },

      {
        path: '/Crisis/Crisis_report', //测评报告
        name: '/Crisis_report',
        meta: { title: '测评报告', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_report.vue'),
      },
      {
        path: '/Crisis/Crisis_talk', //谈心谈话
        name: '/Crisis_talk',
        meta: { title: '谈心谈话', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_talk.vue'),
      },

      {
        path: '/Crisis/Crisis_addmulti_talk', //谈心谈话
        name: '/Crisis_addmulti_talk',
        meta: { title: '谈心谈话', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_addmulti_talk.vue'),
      },

      {
        path: '/Crisis/Crisis_upreport', //重点台账
        name: '/Crisis_upreport',
        meta: { title: '重点台账', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_upreport.vue'),
      },
      {
        path: '/Crisis/Crisis_reporting', //危机上报
        name: '/Crisis_reporting',
        meta: { title: '危机上报', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_reporting.vue'),
      },
      {
        path: '/Crisis/Crisis_statistics',
        name: '/Crisis_statistics',
        meta: { title: '危机统计', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_statistics.vue'),
      },

      {
        path: '/Crisis/Crisis_statistics_unit',
        name: '/Crisis_statistics_unit',
        meta: { title: '危机统计(单位)', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_statistics_unit.vue'),
      },

      {
        path: '/Crisis/Daily_reports', //
        name: '/Daily_reports',
        meta: { title: '危机上报', keepAlive: false },
        component: () => import('../views/Crisis/Daily_reports.vue'),
      },

      {
        path: '/Crisis/Daily_New_account',
        name: '/Daily_New_account',
        meta: { title: '新建台账', keepAlive: false },
        component: () => import('../views/Crisis/Daily_New_account.vue'),
      },


      {
        path: '/Crisis/Hot_wire',
        name: '/Hot_wire',
        meta: { title: '热线详情', keepAlive: false },
        component: () => import('../views/Crisis/Hot_wire.vue'),
      },

      {
        path: '/Crisis/Crisis_lookprefabrication', //
        name: '/Crisis_lookprefabrication',
        meta: { title: '查看台账', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_lookprefabrication.vue'),
      },

      {
        path: '/Crisis/Crisis_detail', //
        name: '/Crisis_detail',
        meta: { title: '查看明细', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_detail.vue'),
      },

      {
        path: '/Crisis/Crisis_details', //
        name: '/Crisis_details',
        meta: { title: '查看上报明细', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_details.vue'),
      },

      {
        path: '/Crisis/Crisis_editprefabrication', //
        name: '/Crisis_editprefabrication',
        meta: { title: '修改重点台账', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_editprefabrication.vue'),
      },


      {
        path: '/Crisis/Crisis_major_consult', //
        name: '/Crisis_major_consult',
        meta: {
          title: '重点访谈', keepAlive: true
        },
        component: () => import('../views/Crisis/Crisis_major_consult.vue'),
      },

      {
        path: '/Crisis/Crisis_lookreport', //
        name: '/Crisis_lookreport',
        meta: { title: '查看危机上报', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_lookreport.vue'),
      },
      {
        path: '/Crisis/Hot_lookreport', //
        name: '/Hot_lookreport',
        meta: { title: '查看危机上报', keepAlive: false },
        component: () => import('../views/Crisis/Hot_lookreport.vue'),
      },

      {
        path: '/Crisis/Crisis_Committee_early', //
        name: '/Crisis_Committee_early',
        meta: { title: '审核', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Committee_early.vue'),
      },

      {
        path: '/Crisis/Crisis_Report_members', //
        name: '/Crisis_Report_members',
        meta: { title: '心理委员上报', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Report_members.vue'),
      },

      {
        path: '/Crisis/Daily_report', //
        name: '/Daily_report',
        meta: { title: '日常危机上报', keepAlive: true },
        component: () => import('../views/Crisis/Daily_report.vue'),
      },

      {
        path: '/Crisis/Review_key', //
        name: '/Review_key',
        meta: { title: '危机主管审核重点访谈', keepAlive: false },
        component: () => import('../views/Crisis/Review_key.vue'),
      },

      // 宣传科普开始

      {
        path: '/propagate/index', //
        name: '/index',
        meta: { title: '内容管理', keepAlive: false },
        component: () => import('../views/propagate/index.vue'),
      },

      {
        path: '/propagate/Material_management', //
        name: '/Material_management',
        meta: { title: '素材管理', keepAlive: false },
        component: () => import('../views/propagate/Material_management.vue'),
      },

      {
        path: '/propagate/Material_management_edit', //
        name: '/Material_management_edit',
        meta: { title: '发布', keepAlive: false },
        component: () => import('../views/propagate/Material_management_edit.vue'),
      },

      {
        path: '/propagate/Sign_in', //
        name: '/Sign_in',
        meta: { title: '测试', keepAlive: false },
        component: () => import('../views/propagate/Sign_in.vue'),
      },
      
      {
        path: '/propagate/Rotation_chart_management', //
        name: '/Rotation_chart_management',
        meta: { title: '轮播图管理', keepAlive: true },
        component: () => import('../views/propagate/Rotation_chart_management.vue'),
      },

      {
        path: '/propagate/app_management', //
        name: '/app_management',
        meta: { title: '轮播图发布', keepAlive: false },
        component: () => import('../views/propagate/app_management.vue'),
      },

      {
        path: '/propagate/Authorization_management', //
        name: '/Authorization_management',
        meta: { title: '授权管理', keepAlive: true },
        component: () => import('../views/propagate/Authorization_management.vue'),
      },
      {
        path: '/propagate/Column_management', //栏目管理
        name: '/Column_management',
        meta: { title: '栏目管理', keepAlive: false },
        component: () => import('../views/propagate/Column_management.vue'),
      },

      {
        path: '/propagate/add_Column', //栏目管理
        name: '/add_Column',
        meta: { title: '新增栏目', keepAlive: false },
        component: () => import('../views/propagate/add_Column.vue'),
      },
      {
        path: '/propagate/edit_Column', //栏目管理
        name: '/edit_Column',
        meta: { title: '修改栏目', keepAlive: false },
        component: () => import('../views/propagate/edit_Column.vue'),
      },
      {
        path: '/propagate/Carousel_map_release', //栏目管理
        name: '/Carousel_map_release',
        meta: { title: '轮播图发布', keepAlive: false },
        component: () => import('../views/propagate/Carousel_map_release.vue'),
      },
      {
        path: '/propagate/Content_review', //
        name: '/Content_review',
        meta: { title: '内容审核', keepAlive: true },
        component: () => import('../views/propagate/Content_review.vue'),
      },

      {
        path: '/propagate/Content_analysis', //
        name: '/propagateContent_analysis',
        meta: { title: '内容分析', keepAlive: false },
        component: () => import('../views/propagate/Content_analysis.vue'),
      },

      {
        path: '/propagate/User_analysis', //
        name: '/propagateUser_analysis',
        meta: { title: '用户分析', keepAlive: false },
        component: () => import('../views/propagate/User_analysis.vue'),
      },

      {
        path: '/propagate/Workload_analysis',
        name: '/Workload_analysis',
        meta: { title: '工作量分析', keepAlive: true },
        component: () => import('../views/propagate/Workload_analysis.vue'),
      },

      {
        path: '/propagate/Video_release', //
        name: '/Video_release',
        meta: { title: '视频发布', keepAlive: false },
        component: () => import('../views/propagate/Video_release.vue'),
      },

      {
        path: '/propagate/Video_edit', //
        name: '/Video_edit',
        meta: { title: '视频发布', keepAlive: false },
        component: () => import('../views/propagate/Video_edit.vue'),
      },
      {
        path: '/propagate/Carousel_release', //轮播图修改
        name: '/Carousel_release',
        meta: { title: '轮播图修改', keepAlive: false },
        component: () => import('../views/propagate/Carousel_release.vue'),
      },
      {
        path: '/propagate/Audio_release', //
        name: '/Audio_release',
        meta: { title: '音频发布', keepAlive: false },
        component: () => import('../views/propagate/Audio_release.vue'),
      },

      {
        path: '/propagate/Propagate_look', //
        name: '/Propagate_look',
        meta: { title: '查看详情', keepAlive: false },
        component: () => import('../views/propagate/Propagate_look.vue'),
      },

      {
        path: '/propagate/Audio_edit', //
        name: '/Audio_edit',
        meta: { title: '音频发布', keepAlive: false },
        component: () => import('../views/propagate/Audio_edit.vue'),
      },

      {
        path: '/propagate/Picture_release', //
        name: '/Picture_release',
        meta: { title: '图片发布', keepAlive: false },
        component: () => import('../views/propagate/Picture_release.vue'),
      },

      {
        path: '/propagate/Picture_edit', //图片修改
        name: '/Picture_edit',
        meta: { title: '图片发布', keepAlive: false },
        component: () => import('../views/propagate/Picture_edit.vue'),
      },

      {
        path: '/propagate/Article_release', //文章发布
        name: '/Article_release',
        meta: { title: '文章发布', keepAlive: false },
        component: () => import('../views/propagate/Article_release.vue'),
      },
      {
        path: '/propagate/Article_releases', //公告发布
        name: '/Article_releases',
        meta: { title: '公告发布', keepAlive: false },
        component: () => import('../views/propagate/Article_releases.vue'),
      },

      {
        path: '/propagate/Article_releasesedit', //公告修改
        name: '/Article_releasesedit',
        meta: { title: '公告修改', keepAlive: false },
        component: () => import('../views/propagate/Article_releasesedit.vue'),
      },
      {
        path: '/propagate/article_edit', //文章编辑
        name: '/article_edit',
        meta: { title: '文章编辑', keepAlive: false },
        component: () => import('../views/propagate/article_edit.vue'),
      },

      {
        path: '/propagate/Workload_analysis_All', //个人工作明细
        name: '/Workload_analysis_All',
        meta: { title: '个人工作明细', keepAlive: false },
        component: () => import('../views/propagate/Workload_analysis_All.vue'),
      },

      {
        path: '/propagate/Workload_Income_allocation', //
        name: '/Workload_Income_allocation',
        meta: { title: '收益配置', keepAlive: false },
        component: () => import('../views/propagate/Workload_Income_allocation.vue'),
      },{
        path: '/propagate/Hotline_management', //
        name: '/Hotline_management',
        meta: { title: '热线清单', keepAlive: false },
        component: () => import('../views/propagate/Hotline_management.vue'),
      },{
        path: '/propagate/Workload_statistics', //
        name: '/Workload_statistics',
        meta: { title: '工作量统计', keepAlive: false },
        component: () => import('../views/propagate/Workload_statistics.vue'),
      },{
        path: '/propagate/Labor_cost_statistics', //
        name: '/Labor_cost_statistics',
        meta: { title: '工作统计', keepAlive: false },
        component: () => import('../views/propagate/Labor_cost_statistics.vue'),
      },{
        path: '/propagate/Work_statistics', //
        name: '/Work_statistics',
        meta: { title: '劳务费统计', keepAlive: false },
        component: () => import('../views/propagate/Work_statistics.vue'),
      },

      // 宣传科普结束

      {
        path: '/Crisis/Crisis_evaluation_view', //
        name: '/Crisis_evaluation_view',
        meta: { title: '查看访谈表', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_evaluation_view.vue'),
      },
      {
        path: '/Crisis/Crisis_evaluation_grading', //
        name: '/Crisis_evaluation_grading',
        meta: { title: '访谈审核', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_evaluation_grading.vue'),
      },
      {
        path: '/Crisis/Crisis_Memcon_view', //
        name: '/Crisis_Memcon_view',
        meta: { title: '查看谈话记录', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Memcon_view.vue'),
      },

      {
        path: '/Crisis/Crisis_Intervent_Committee', //
        name: '/Crisis_Intervent_Committee',
        meta: {
          title: '危机干预-心理委员', keepAlive: true 
        },
        component: () => import('../views/Crisis/Crisis_Intervent_Committee.vue'),
      },

      {
        path: '/Crisis/Memcon_modify', //
        name: '/Memcon_modify',
        meta: { title: '修改谈话记录', keepAlive: false },
        component: () => import('../views/Crisis/Memcon_modify.vue'),
      },

      {
        path: '/Crisis/Crisis_Memcon_audit', //
        name: '/Crisis_Memcon_audit',
        meta: { title: '谈话记录审批', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Memcon_audit.vue'),
      },

      // {
      //   path: '/Crisis/Hotline_Crisis_Synchronization', //
      //   name: '/Hotline_Crisis_Synchronization',
      //   meta: { title: '热线危机同步' },
      //   component: () =>
      //     import('../views/Crisis/Hotline_Crisis_Synchronization.vue'),
      // },

      {
        path: '/Crisis/Crisis_evaluation_account', //
        name: '/Crisis_evaluation_account',
        meta: { title: '填写台账', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_evaluation_account.vue'),
      },

      {
        path: '/Crisis/Crisis_Counselor_intervention', //
        name: '/Crisis_Counselor_intervention',
        meta: { title: '安排咨询师介入', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Counselor_intervention.vue'),
      },


      {
        path: '/Crisis/Crisis_evaluation_audit', //
        name: '/Crisis_evaluation_audit',
        meta: { title: '风险监控员筛选', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_evaluation_audit.vue'),
      },

      {
        path: '/Crisis/Crisis_Intervent', //过程记录
        name: '/Crisis_Intervent',
        meta: { title: '过程记录', keepAlive: false 
       },
        component: () => import('../views/Crisis/Crisis_Intervent.vue'),
      },

      {
        path: '/Crisis/Psychological_archives', //心理档案
        name: '/Psychological_archives',
        meta: { title: '心理档案', keepAlive: false },
        component: () => import('../views/Crisis/Psychological_archives.vue'),
      },
      {
        path: '/Crisis/Crisis_Intervention_File', //心理档案
        name: '/Crisis_Intervention_File',
        meta: { title: '危机干预档案', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Intervention_File.vue'),
      },

      {
        path: '/Crisis/Crisis_Memcon_apply', //心理档案
        name: '/Crisis_Memcon_apply',
        meta: { title: '申请调整', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Memcon_apply.vue'),
      },
      {
        path: '/Crisis/Crisis_Memcon_evaluation', //心理档案
        name: '/Crisis_Memcon_evaluation',
        meta: { title: '咨询师评估', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Memcon_evaluation.vue'),
      },
      {
        path: '/Crisis/Crisis_Reporting_file', //心理档案
        name: '/Crisis_Reporting_file',
        meta: { title: '危机上报档案档案', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_Reporting_file.vue'),
      },
      {
        path: '/Crisis/Evaluation_report_file', //心理档案
        name: '/Evaluation_report_file',
        meta: { title: '测评报告档案', keepAlive: false },
        component: () => import('../views/Crisis/Evaluation_report_file.vue'),
      },
      {
        path: '/Crisis/Crisis_document', //心理档案
        name: '/Crisis_document',
        meta: { title: '学生档案', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_document.vue'),
      },
      {
        path: '/Crisis/Crisis_warning', //危机警告
        name: '/Crisis_warning',
        meta: { title: '危机警告', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_warning.vue'),
      },

      {
        path: '/Crisis/report', //危机警告
        name: '/report',
        meta: { title: '危机内容上报', keepAlive: false },
        component: () => import('../views/Crisis/report.vue'),
      },

      {
        path: '/Crisis/Daily_Autonomous_report', //危机警告
        name: '/Daily_Autonomous_report',
        meta: { title: '自主上报', keepAlive: false },
        component: () => import('../views/Crisis/Daily_Autonomous_report.vue'),
      },



      {
        path: '/Crisis/Crisis_major_candidate', //危机警告
        name: '/Crisis_major_candidate',
        meta: { title: '候补详情', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_major_candidate.vue'),
      },

      {
        path: '/Crisis/Memcon',//危机警告
        name: '/Memcon',
        meta: { title: '谈话记录', keepAlive: false },
        component: () => import('../views/Crisis/Memcon.vue'),
      },
      {
        path: '/Crisis/Multiparty',//多方会谈
        name: '/Multiparty',
        meta: { title: '多方会谈', keepAlive: false },
        component: () => import('../views/Crisis/Multiparty.vue'),
      },
      {
        path: '/Crisis/Crisis_intervention',//危机警告
        name: 'Crisis_intervention',
        meta: { title: '危机干预', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_intervention.vue'),
      },

      {
        path: '/Crisis/Crisis_major_event',//危机警告
        name: 'Crisis_major_event',
        meta: { title: '重大事件', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_major_event.vue'),
      },
      {
        path: '/Crisis/Crisis_addmajor_event',//添加重大事件
        name: 'Crisis_addmajor_event',
        meta: { title: '风险台账', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_addmajor_event.vue'),
      },

      {
        path: '/Crisis/Crisis_addtalk',//添加重大事件
        name: 'Crisis_addtalk',
        meta: { title: '谈话记录', keepAlive: false },
        component: () => import('../views/Crisis/Crisis_addtalk.vue'),
      },

      {
        path: '/CounselorLeave/CounselorIndex',//首页
        name: '/CounselorIndex',
        meta: { title: '申请请假', keepAlive: false },
        component: () => import('../views/CounselorLeave/CounselorIndex.vue'),
      },

      {
        path: '/Scale/Scale_classification',//量表分类
        name: '/Scale_classification',
        meta: { title: '量表管理', keepAlive: false },
        component: () => import('../views/Scale/Scale_classification.vue'),
      },
      {
        path: '/Scale/Add_scale',//量表分类
        name: '/Add_scale',
        meta: { title: '新增量表', keepAlive: false },
        component: () => import('../views/Scale/Add_scale.vue'),
      },

      {
        path: '/Scale/Scale_instruction',//量表分类
        name: '/Scale_instruction',
        meta: { title: '指导语管理', keepAlive: false },
        component: () => import('../views/Scale/Scale_instruction.vue'),
      },
      {
        path: '/Scale/Add_instruction',//量表分类
        name: '/Add_instruction',
        meta: { title: '添加指导语', keepAlive: false },
        component: () => import('../views/Scale/Add_instruction.vue'),
      },

      {
        path: '/Scale/Scale_factor_problem',//量表分类
        name: '/Scale_factor_problem',
        meta: { title: '因子题目配置', keepAlive: false },
        component: () => import('../views/Scale/Scale_factor_problem.vue'),
      },

      {
        path: '/Scale/Add_factor_problem',//量表分类
        name: '/Add_factor_problem',
        meta: { title: '添加因子题目', keepAlive: false },
        component: () => import('../views/Scale/Add_factor_problem.vue'),
      },

      {
        path: '/Scale/Scale_factor_answer',//量表分类
        name: '/Scale_factor_answer',
        meta: { title: '因子题目答案配置', keepAlive: false },
        component: () => import('../views/Scale/Scale_factor_answer.vue'),
      },

      {
        path: '/Scale/Add_factor_answer',//量表分类
        name: '/Add_factor_answer',
        meta: { title: '添加因子题目', keepAlive: false },
        component: () => import('../views/Scale/Add_factor_answer.vue'),
      },

      {
        path: '/Scale/Scale_table_jump',//量表分类
        name: '/Scale_table_jump',
        meta: { title: '量表跳转', keepAlive: false },
        component: () => import('../views/Scale/Scale_table_jump.vue'),
      },

      {
        path: '/Scale/Add_table_jump',//量表分类
        name: '/Add_table_jump',
        meta: { title: '新增题目跳转', keepAlive: false },
        component: () => import('../views/Scale/Add_table_jump.vue'),
      },

      {
        path: '/Scale/Scale_topic_addition',//量表分类
        name: '/Scale_topic_addition',
        meta: { title: '题目添加配置', keepAlive: false },
        component: () => import('../views/Scale/Scale_topic_addition.vue'),
      },

      {
        path: '/Scale/Add_topic',//量表分类
        name: '/Add_topic',
        meta: { title: '新增题目添加配置', keepAlive: false },
        component: () => import('../views/Scale/Add_topic.vue'),
      },

      {
        path: '/Scale/Scale_Problem_presentation',//量表分类
        name: '/Scale_Problem_presentation',
        meta: { title: '题目展示配置', keepAlive: false },
        component: () => import('../views/Scale/Scale_Problem_presentation.vue'),
      },

      {
        path: '/Scale/Add_Problem_presentation',//量表分类
        name: '/Add_Problem_presentation',
        meta: { title: '新增题目展示', keepAlive: false },
        component: () => import('../views/Scale/Add_Problem_presentation.vue'),
      },

      {
        path: '/Scale/Scale_skip_question',//量表分类
        name: '/Scale_skip_question',
        meta: { title: '跳题管理', keepAlive: false },
        component: () => import('../views/Scale/Scale_skip_question.vue'),
      },

      {
        path: '/Scale/Add_skip_question',//量表分类
        name: '/Add_skip_question',
        meta: { title: '新增跳题', keepAlive: false },
        component: () => import('../views/Scale/Add_skip_question.vue'),
      },

      {
        path: '/Set/Set_clean', //测试数据清理
        name: '/Set_clean',
        meta: { title: '数据管理', keepAlive: false },
        component: () => import('../views/Set/Set_clean.vue'),
      },

      {
        path: '/Set/Set_basis', //工作台
        name: '/Set_basis',
        meta: { title: '工作台', keepAlive: false },
        component: () => import('../views/Set/Set_basis.vue'),
      },

      {
        path: '/Set/Set_basisbeifen', //工作台
        name: '/Set_basisbeifen',
        meta: { title: '工作台2', keepAlive: false },
        component: () => import('../views/Set/Set_basisbeifen.vue'),
      },


      

      {
        path: '/Set/Aggregate_statistics', //工作台
        name: '/Aggregate_statistics',
        meta: { title: '总体统计', keepAlive: false },
        component: () => import('../views/Set/Aggregate_statistics.vue'),
      },

      {
        path: '/Set/Certificate_setting', //证书设置
        name: '/Certificate_setting',
        meta: { title: '证书设置', keepAlive: false },
        component: () => import('../views/Set/Certificate_setting.vue'),
      },

      {
        path: '/Set/Set_database', //数据库清理
        name: '/Set_database',
        meta: { title: '数据库清理', keepAlive: false },
        component: () => import('../views/Set/Set_database.vue'),
      },

      {
        path: '/Set/Dictionary_level', //数据库清理
        name: '/Dictionary_level',
        meta: { title: '字典数据管理', keepAlive: true },
        component: () => import('../views/Set/Dictionary_level.vue'),
      },

      {
        path: '/Set/Dictionary_type', //数据库清理
        name: '/Dictionary_type',
        meta: { title: '字典类型管理', keepAlive: true },
        component: () => import('../views/Set/Dictionary_type.vue'),
      },

      {
        path: '/Archives_management/File_add_record', //宣传审核
        name: '/File_add_record',
        meta: { title: '添加重要记录', keepAlive: false },
        component: () =>
          import('../views/Archives_management/File_add_record.vue'),
      },

      {
        path: '/Archives_management/File_add_consultation', //宣传审核
        name: '/File_add_consultation',
        meta: { title: '咨询记录', keepAlive: false },
        component: () =>
          import('../views/Archives_management/File_add_consultation.vue'),
      },

      {
        path: '/Archives_management/Personal_file', //个人档案
        name: '/Personal_file',
        meta: { title: '个人档案', keepAlive: false },
        component: () =>
          import('../views/Archives_management/Personal_file.vue'),
      },

      {
        path: '/Archives_management/File_view', //个人档案
        name: '/File_view',
        meta: { title: '查看档案', keepAlive: false },
        component: () => import('../views/Archives_management/File_view.vue'),
      },

      {
        path: '/Archives_management/File_modification_important', //个人档案
        name: '/File_modification_important',
        meta: { title: '修改重要记录', keepAlive: false },
        component: () =>
          import(
            '../views/Archives_management/File_modification_important.vue'
          ),
      },

      {
        path: '/Archives_management/File_individual', //个人档案
        name: '/File_individual',
        meta: { title: '添加档案', keepAlive: false },
        component: () =>
          import('../views/Archives_management/File_individual.vue'),
      },
      {
        path: '/Archives_management/File_list', //个人档案
        name: '/File_list',
        meta: { title: '档案列表', keepAlive: false },
        component: () => import('../views/Archives_management/File_list.vue'),
      },
      {
        path: '/Archives_management/File_record_list', //个人档案列表
        name: '/File_record_list',
        meta: { title: '个人档案列表', keepAlive: false },
        component: () =>
          import('../views/Archives_management/File_record_list.vue'),
      },
      {
        path: '/Data/All_data', //大数据
        name: '/All_data',
        meta: { title: '大数据', keepAlive: false },
        component: () => import('../views/Data/All_data'),
      },

      {
        path: '/Data/Big_data', //大数据
        name: '/Big_data',
        meta: { title: '大数据中心', keepAlive: false },
        component: () => import('../views/Data/Big_data'),
      },

      {
        path: '/Data/Monthly',
        name: '/Monthly',
        meta: { title: '月报内容', keepAlive: false },
        component: () => import('../views/Data/Monthly.vue'),
      },

      {
        path: '/Data/Relax',
        name: '/Relax',
        meta: { title: '放松舱报告', keepAlive: false },
        component: () => import('../views/Data/Relax'),
      },


      
      {
        path: '/training/Training_all', //认知训练
        name: '/Training_all',
        meta: { title: '全部训练', keepAlive: false },
        component: () => import('../views/training/Training_all'),
      },
      {
        path: '/training/Game_a_type', //认知训练
        name: '/Game_a_type',
        meta: { title: '类型', keepAlive: false },
        component: () => import('../views/training/Game_a_type'),
      },

      {
        path: '/training/Game_alip_elimination', //认知训练
        name: '/Game_alip_elimination',
        meta: { title: '数字消除', keepAlive: false },
        component: () => import('../views/training/Game_alip_elimination'),
      },
      {
        path: '/training/Game_memory_span', //认知训练
        name: '/Game_memory_span',
        meta: { title: '记忆广度', keepAlive: false },
        component: () => import('../views/training/Game_memory_span'),
      },
      {
        path: '/training/Game_vision', //认知训练
        name: '/Game_vision',
        meta: { title: '视觉控制力', keepAlive: false },
        component: () => import('../views/training/Game_vision'),
      },
      {
        path: '/training/Game_mental_rotation', //认知训练
        name: '/Game_mental_rotation',
        meta: { title: '心理表象', keepAlive: false },
        component: () => import('../views/training/Game_mental_rotation'),
      },
      {
        path: '/training/Game_short_memory', //认知训练
        name: '/Game_short_memory',
        meta: { title: '短时记忆力', keepAlive: false },
        component: () => import('../views/training/Game_short_memory'),
      },
      {
        path: '/training/Game_reaction_rate', //认知训练
        name: '/Game_reaction_rate',
        meta: { title: 'ex反应速度' , keepAlive: false },
        component: () => import('../views/training/Game_reaction_rate'),
      },
      {
        path: '/training/Game_pattern_matching', //认知训练
        name: '/Game_pattern_matching',
        meta: { title: 'Ex-句子-图形匹配', keepAlive: false },
        component: () => import('../views/training/Game_pattern_matching'),
      }, {
        path: '/Game/TrainingIntro', //训练简介及难度选择
        name: '/TrainingIntro',
        meta: { title: '训练简介', keepAlive: false },
        component: () => import('../views/Game/TrainingIntro'),
      }, {
        path: '/Propaganda/Material', //宣传素材
        name: '/Material',
        meta: { title: '宣传素材', keepAlive: false },
        component: () => import('../views/Propaganda/Material.vue'),
      },
      
      {
        path: '/Propaganda/Audit', //宣传审核
        name: '/Audit',
        meta: { title: '宣传审核', keepAlive: false },
        component: () => import('../views/Propaganda/Audit.vue'),
      },

      {
        path: '/Propaganda/Content_analysis', //宣传审核
        name: '/Content_analysis',
        meta: { title: '内容分析', keepAlive: false },
        component: () => import('../views/Propaganda/Content_analysis.vue'),
      },

      {
        path: '/Propaganda/User_analysis', //宣传审核
        name: '/User_analysis',
        meta: { title: '用户分析', keepAlive: false },
        component: () => import('../views/Propaganda/User_analysis.vue'),
      },

      {
        path: '/Propaganda/Authorization', //宣传授权
        name: '/Authorization',
        meta: { title: '宣传授权', keepAlive: false },
        component: () => import('../views/Propaganda/Authorization.vue'),
      },

      {
        path: '/Set/Set_permissions', //权限设置
        name: '/Set_permissions',
        meta: { title: '功能权限管理', keepAlive: false },
        component: () => import('../views/Set/Set_permissions.vue'),
      },
      {
        path: '/Visitors', //信息管理
        name: 'Visitors',
        meta: { title: '信息管理', keepAlive: false },
        component: () => import('../views/Measurement/Visitors/index.vue'),
      },
      {
        path: '/Visitors/Waiting_test', //待测试
        name: 'Waiting_test',
        meta: { title: '待测试量表', keepAlive: false },
        component: () =>
          import('../views/Measurement/Visitors/Waiting_test.vue'),
      },
      {
        path: '/Visitors/Already_test', //测试记录
        name: 'Already_test',
        meta: { title: '测试记录', keepAlive: true },
        component: () =>
          import('../views/Measurement/Visitors/Already_test.vue'),
      },

      {
        path: '/Visitors/Evaluation_statistics', //测试记录
        name: 'Evaluation_statistics',
        meta: { title: '测试统计', keepAlive: true },
        component: () =>
          import('../views/Measurement/Visitors/Evaluation_statistics.vue'),
      },


      {
        path: '/Visitors/Already_ltest', //已测试记录
        name: 'Already_ltest',
        meta: { title: '已测试记录', keepAlive: true },
        component: () =>
          import('../views/Measurement/Visitors/Already_ltest.vue'),
      },
      {
        path: '/Visitors/MyPaperReportList', //我的测试记录
        name: 'MyPaperReportList',
        meta: { title: '我的测试记录', keepAlive: false },
        component: () =>
          import('../views/Measurement/Visitors/MyPaperReportList.vue'),
      },

      {
        path: '/Interview/Conference_room', //我的测试记录
        name: 'Conference_room',
        meta: { title: '会议室管理', keepAlive: true },
        component: () => import('../views/Interview/Conference_room.vue'),
      },

      {
        path: '/Interview/Interview_typesetting', //我的测试记录
        name: 'Interview_typesetting',
        meta: { title: '访谈排班', keepAlive: false },
        component: () => import('../views/Interview/Interview_typesetting.vue'),
      },

      {
        path: '/Measurement', //信息管理
        name: 'Measurement',
        meta: { title: '心理测评', keepAlive: false },
        component: () => import('../views/Measurement/index.vue'),
      },

      {
        path: '/Measurement/add', //列表展示
        name: 'add',
        meta: { title: '新建发布', keepAlive: false },
        component: () => import('../views/Measurement/add.vue'),
      },

      {
        path: '/Measurement/addTeamMeasure', //增加团队测评
        name: 'addTeamMeasure',
        meta: { title: '增加团队测评', keepAlive: false },
        component: () => import('../views/Measurement/addTeamMeasure.vue'),
      },
      {
        path: '/Measurement/Interview_notice', //访谈通知
        name: 'Interview_notice',
        meta: { title: '访谈通知', keepAlive: false },
        component: () => import('../views/Measurement/Interview_notice.vue'),
      },

      {
        path: '/Measurement/Message_preview', //消息预览
        name: 'Message_preview',
        meta: { title: '消息预览', keepAlive: false },
        component: () => import('../views/Measurement/Message_preview.vue'),
      },

      {
        path: '/Measurement/AllPaperTest', //列表展示
        name: 'AllPaperTest',
        meta: { title: '全部量表测试', keepAlive: false },
        component: () => import('../views/Measurement/AllPaperTest.vue'),
      },

      {
        path: '/Measurement/Interview_brief', //列表展示
        name: 'Interview_brief',
        meta: { title: '心理访谈情况简报', keepAlive: false },
        component: () => import('../views/Measurement/Interview_brief.vue'),
      },

      {
        path: '/Measurement/Health_report', //列表展示
        name: 'Health_report',
        meta: { title: '健康报告', keepAlive: false },
        component: () => import('../views/Measurement/Health_report.vue'),
      },

      {
        path: '/Measurement/Mental_health_report', //列表展示
        name: 'Mental_health_report',
        meta: { title: '大学学生心理健康报告', keepAlive: false },
        component: () => import('../views/Measurement/Mental_health_report.vue'),
      },

      {
        path: '/Measurement/InterviewAppointment', //访谈预约
        name: 'InterviewAppointment',
        meta: { title: '访谈预约', keepAlive: false },
        component: () => import('../views/Measurement/InterviewAppointment.vue'),
      },
      {
        path: '/Measurement/AppointmentRecord', //预约记录
        name: 'AppointmentRecord',
        meta: { title: '预约记录', keepAlive: false },
        component: () => import('../views/Measurement/AppointmentRecord.vue'),
      },
      {
        path: '/Measurement/PaperTest', //列表展示
        name: 'PaperTest',
        meta: { title: '测试', keepAlive: false },
        component: () => import('../views/Measurement/PaperTest.vue'),
      },
      {
        path: '/Measurement/PaperTest_WebsterSpeech', //列表展示
        name: 'PaperTest_WebsterSpeech',
        meta: { title: '测试', keepAlive: false },
        component: () =>
          import('../views/Measurement/PaperTest_WebsterSpeech.vue'),
      },
      {
        path: '/Measurement/PaperTest_WebsterAdult', //列表展示
        name: 'PaperTest_WebsterAdult',
        meta: { title: '测试', keepAlive: false },
        component: () =>
          import('../views/Measurement/PaperTest_WebsterAdult.vue'),
      },
      {
        path: '/Measurement/PaperTest_WebsterMemory', //列表展示
        name: 'PaperTest_WebsterMemory',
        meta: { title: '测试', keepAlive: false },
        component: () =>
          import('../views/Measurement/PaperTest_WebsterMemory.vue'),
      },
      {
        path: '/Measurement/Modifyadd', //修改发布
        name: 'Modifyadd',
        meta: { title: '修改发布', keepAlive: false },
        component: () => import('../views/Measurement/Modifyadd.vue'),
      },
      {
        path: '/Measurement/ModifyTeamMeasure', //修改团体测评
        name: 'ModifyTeamMeasure',
        meta: { title: '部门测评发布', keepAlive: false },
        component: () => import('../views/Measurement/ModifyTeamMeasure.vue'),
      },
      {
        path: '/Measurement/DetailTeamMeasure', //修改团体测评
        name: 'DetailTeamMeasure',
        meta: { title: '部门测评详情', keepAlive: false },
        component: () => import('../views/Measurement/DetailTeamMeasure.vue'),
      },
      {
        path: '/user/User', //列表展示
        name: 'User',
        meta: { title: '用户中心', keepAlive: false },
        component: () => import('../views/user/User.vue'),
      },
      {
        path: '/user/User_add', //列表展示
        name: 'User_add',
        meta: { title: '添加用户', keepAlive: false },
        component: () => import('../views/user/User_add.vue'),
      },
      {
        path: '/user/User_addsingle', //列表展示
        name: 'User_addsingle',
        meta: { title: '单个添加', keepAlive: false },
        component: () => import('../views/user/User_addsingle.vue'),
      },
      {
        path: '/user/User_addmore', //列表展示
        name: 'User_addmore',
        meta: { title: '批量导入', keepAlive: false },
        component: () => import('../views/user/User_addsingle.vue'),
      },
      {
        path: '/user/User_management', //列表展示
        name: 'User_management',
        meta: { title: '用户中心', keepAlive: false },
        component: () => import('../views/user/User_management.vue'),
      },
      {
        path: '/user/User_personal', //列表展示
        name: 'User_personal',
        meta: { title: '个人资料', keepAlive: true },
        component: () => import('../views/user/User_personal.vue'),
      },
      {
        path: '/user/User_modify', //列表展示
        name: 'User_modify',
        meta: { title: '修改密码', keepAlive: false },
        component: () => import('../views/user/User_modify.vue'),
      },
      {
        path: '/user/User_personalinformation', //列表展示
        name: 'User_personalinformation',
        meta: { title: '个人信息完善', keepAlive: false },
        component: () => import('../views/user/User_personalinformation.vue'),
      },
      {
        path: '/Measurement/Scblock', //列表展示
        name: 'Scblock',
        meta: { title: '全部量表', keepAlive: false },
        component: () => import('../views/Measurement/Scblock.vue'),
      },
      {
        path: '/Measurement/Test', //列表展示
        name: 'Test',
        meta: { title: '测试情况', keepAlive: true },
        component: () => import('../views/Measurement/Test.vue'),
      },
      {
        path: '/Measurement/Notest', //列表展示
        name: 'Notest',
        meta: { title: '未测试', keepAlive: false },
        component: () => import('../views/Measurement/Notest.vue'),
      },
      {
        path: '/Measurement/Alreadytest', //列表展示
        name: 'Alreadytest',
        meta: { title: '已经测试', keepAlive: false },
        component: () => import('../views/Measurement/Alreadytest.vue'),
      },
      {
        path: '/Measurement/Originaldata', //列表展示
        name: 'Originaldata',
        meta: { title: '原始数据', keepAlive: true },
        component: () => import('../views/Measurement/Originaldata.vue'),
      },
      {
        path: '/Measurement/Indata', //列表展示
        name: 'Indata',
        meta: { title: '原始数据导入', keepAlive: false },
        component: () => import('../views/Measurement/Indata.vue'),
      },
      {
        path: '/Measurement/Archives', //列表展示
        name: 'Archives',
        meta: { title: '档案', keepAlive: false },
        component: () => import('../views/Measurement/Archives.vue'),
      },
      {
        path: '/Measurement/Grouparchives', //列表展示
        name: 'Grouparchives',
        meta: { title: '部门测评档案', keepAlive: false },
        component: () => import('../views/Measurement/Grouparchives.vue'),
      },

      {
        path: '/Measurement/Personalarchives', //列表展示
        name: 'Personalarchives',
        meta: { title: '个人档案', keepAlive: false },
        component: () => import('../views/Measurement/Personalarchives.vue'),
      },
      {
        path: '/Measurement/Trackarchives', //列表展示
        name: 'Trackarchives',
        meta: { title: '档案追踪', keepAlive: false },
        component: () => import('../views/Measurement/Trackarchives.vue'),
      },
      {
        path: '/Measurement/Published', //列表展示
        name: 'Published',
        meta: { title: '普测发布管理', keepAlive: false },
        component: () => import('../views/Measurement/Published.vue'),
      },
      {
        path: '/Scale/Discipline_talk', //列表展示
        name: 'Discipline_talk',
        meta: { title: '管教谈话', keepAlive: false },
        component: () => import('../views/Scale/Discipline_talk.vue'),
      },
      {
        path: '/Measurement/PublishedTeam', //团体测评列表展示
        name: 'PublishedTeam',
        meta: { title: '团体测评发布', keepAlive: false },
        component: () => import('../views/Measurement/PublishedTeam.vue'),
      },
      {
        path: '/Measurement/addpackage', //新增套餐
        name: 'addpackage',
        meta: { title: '新增套餐', keepAlive: false },
        component: () => import('../views/Measurement/addpackage.vue'),
      },
      {
        path: '/Measurement/Package', //新增套餐
        name: 'Package',
        meta: { title: '发布套餐管理', keepAlive: false },
        component: () => import('../views/Measurement/Package.vue'),
      },
      {
        path: '/Measurement/Modifypackage', //修改套餐
        name: 'Modifypackage',
        meta: { title: '修改套餐', keepAlive: false },
        component: () => import('../views/Measurement/Modifypackage.vue'),
      },
      
      {
        path: '/Measurement/significance', //修改套餐
        name: 'significance',
        meta: { title: '显著性分析', keepAlive: false },
        component: () => import('../views/Measurement/significance.vue'),
      },
      {
        path: '/Measurement/significance_report', //修改套餐
        name: 'significance_report',
        meta: { title: '显著性分析报告', keepAlive: false },
        component: () => import('../views/Measurement/significance_report.vue'),
      },
      {
        path: '/Measurement/significance_add', //修改套餐
        name: 'significance',
        meta: { title: '显著性分析新增', keepAlive: false },
        component: () => import('../views/Measurement/significance_add.vue'),
      },
      {
        path: '/Consultant/Consultingadd', //修改套餐
        name: 'Consultingadd',
        meta: { title: '添加排班', keepAlive: false },
        component: () => import('../views/Consultant/Consultingadd.vue'),
      },
      {
        path: '/Consultant/AppointmentList', //预约记录列表
        name: 'AppointmentList',
        meta: { title: '预约记录', keepAlive: true },
        component: () => import('../views/Consultant/AppointmentList'),
      },
      {
        path: '/Consultant/AppointmentList_1', //预约记录列表1
        name: 'AppointmentList_1',
        meta: { title: '预约记录1', keepAlive: true },
        component: () => import('../views/Consultant/AppointmentList_1.vue'),
      },
      {
        path: '/Set', //预约记录列表
        name: 'ApplyApproval',
        meta: { title: '申请审批', keepAlive: false },
        component: () => import('../views/Set/'),
      },
      {
        path: '/CounselorLeave/ConsultingAppointAdd', //添加排班并直接预约
        name: 'ConsultingAppointAdd',
        meta: { title: '添加排班并预约', keepAlive: false },
        component: () => import('../views/CounselorLeave/ConsultingAppointAdd'),
      },
      {
        path: '/CounselorLeave/CancelReservation', //取消预约
        name: '/CancelReservation.vue',
        meta: { title: '取消预约', keepAlive: true },
        component: () =>
          import('../views/CounselorLeave/CancelReservation.vue'),
      },
      {
        path: '/CounselorLeave/ApplyRelease', //申请解禁
        name: '/ApplyRelease.vue',
        meta: { title: '申请解禁', keepAlive: false },
        component: () => import('../views/CounselorLeave/ApplyRelease.vue'),
      },
      {
        path: '/CounselorLeave/ConsultingBlacklist', //黑名单
        name: '/ConsultingBlacklist.vue',
        meta: { title: '咨询限制名单', keepAlive: false },
        component: () =>
          import('../views/CounselorLeave/ConsultingBlacklist.vue'),
      },
      {
        path: '/CounselorLeave/ConsultingLong', //黑名单
        name: '/ConsultingLong.vue',
        meta: { title: '长期咨询', keepAlive: true },
        component: () => import('../views/CounselorLeave/ConsultingLong.vue'),
      },
      {
        path: '/CounselorLeave/Consultation_appointment', //咨询预约
        name: '/Consultation_appointment.vue',
        meta: { title: '咨询预约', keepAlive: true },
        component: () => import('../views/CounselorLeave/Consultation_appointment.vue'),
      },
      {
        path: '/CounselorLeave/Consultation_mail', //站内信
        name: '/Consultation_mail.vue',
        meta: { title: '站内信', keepAlive: false },
        component: () => import('../views/CounselorLeave/Consultation_mail.vue'),
      },{
        path: '/CounselorLeave/Email', //Email
        name: '/Email.vue',
        meta: { title: '发送邮件', keepAlive: false },
        component: () => import('../views/CounselorLeave/Email.vue'),
      },
      {
        path: '/CounselorLeave/ConsultRecord', //我的咨询
        name: '/ConsultRecord.vue',
        meta: { title: '我的咨询', keepAlive: false },
        component: () => import('../views/CounselorLeave/ConsultRecord.vue'),
      },
      {
        path: '/Consultant/ConsultantWork', //咨询师工作台
        name: '/ConsultantWork.vue',
        meta: { title: '请假审批', keepAlive: false },
        component: () => import('../views/Consultant/ConsultantWork.vue'),
      },
      // {
      //   path: '/Admin/ExamineIndex', //管理员所有审批功能的页面
      //   name: '/ExamineIndex.vue',
      //   meta: { title: '审批' },
      //   component: () => import('../views/Admin/ExamineIndex.vue'),
      // },
      {
        path: '/DropDownMng_WorkGroup', //工作小组管理
        name: 'DropDownMng_WorkGroup',
        meta: { title: '工作小组管理', keepAlive: false },
        component: () => import('../views/Admin/DropDownMng.vue'),
      },
      {
        path: '/DropDownMng_MaterialLabe', //标签管理
        name: 'DropDownMng_MaterialLabe',
        meta: { title: '标签管理', keepAlive: false },
        component: () => import('../views/Admin/DropDownMng.vue'),
      },
      {
        path: '/Admin/ExamineLeave', //管理员审批请假的具体功能页面
        name: '/ExamineLeave.vue',
        meta: { title: '请假审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineLeave.vue'),
      },
      {
        path: '/Admin/ExamineAppointment', //管理员审批请假的具体功能页面
        name: '/ExamineAppointment.vue',
        meta: { title: '取消预约审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineAppointment.vue'),
      },
      {
        path: '/Admin/ExamineBan', //管理员审批请假的具体功能页面
        name: '/ExamineBan.vue',
        meta: { title: '解禁审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineBan.vue'),
      },
      {
        path: '/Admin/ExamineLongConsult', //管理员审批长期咨询的具体功能页面
        name: '/ExamineLongConsult.vue',
        meta: { title: '长期咨询审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineLongConsult.vue'),
      },
      {
        path: '/Admin/ExamineBlackList', //管理员审批黑名单的具体功能页面
        name: '/ExamineBlackList.vue',
        meta: { title: '限制名单审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineBlackList.vue'),
      },

      {
        path: '/Admin/ExamineConsultant', //管理员审批黑名单的具体功能页面
        name: '/ExamineConsultant.vue',
        meta: { title: '咨询师审核', keepAlive: false },
        component: () => import('../views/Admin/ExamineConsultant.vue'),
      },

      {
        path: '/Admin/ExamineRevision_review', //管理员审批黑名单的具体功能页面
        name: '/ExamineRevision_review.vue',
        meta: { title: '激活审核', keepAlive: true },
        component: () => import('../views/Admin/ExamineRevision_review.vue'),
      },

      {
        path: '/Admin/ExamineTeamMeasure', //管理员审批黑名单的具体功能页面
        name: '/ExamineTeamMeasure.vue',
        meta: { title: '测评审核', keepAlive: false },
        component: () => import('../views/Admin/ExamineTeamMeasure.vue'),
      },


      {
        path: '/Admin/ExamineConsultReport', //管理员审批咨询师申请查看报告页面
        name: '/ExamineConsultReport.vue',
        meta: { title: '报告查看审批', keepAlive: false },
        component: () => import('../views/Admin/ExamineConsultReport.vue'),
      },

      {
        path: '/Admin/BlackListMng', //管理员管理黑名单功能页面
        name: '/BlackListMng.vue',
        meta: { title: '限制名单管理', keepAlive: true },
        component: () => import('../views/Admin/BlackListMng.vue'),
      },

      {
        path: '/Admin/ExamineStatistical', //管理员预约咨询统计
        name: '/ExamineStatistical.vue',
        meta: { title: '咨询统计', keepAlive: false },
        component: () => import('../views/Admin/ExamineStatistical.vue'),
      },

      {
        path: '/Admin/Monthly_statistics',
        name: '/Monthly_statistics.vue',
        meta: { title: '心理咨询月度统计', keepAlive: false },
        component: () => import('../views/Admin/Monthly_statistics.vue'),
      },

      {
        path: '/Admin/CertifiedConsultant', //咨询师认证
        name: '/CertifiedConsultant.vue',
        meta: { title: '咨询师认证', keepAlive: true },
        component: () => import('../views/Admin/CertifiedConsultant.vue'),
      },
      {
        path: '/Psychological/Hours_statistics', //小时统计
        name: '/Hours_statistics.vue',
        meta: { title: '小时统计', keepAlive: true },
        component: () => import('../views/Psychological/Hours_statistics.vue'),
      },

      {
        path: '/Activity', //系统设置
        name: 'Activity',
        meta: { title: '活动', keepAlive: false },
        component: () => import('../views/Activity/index.vue'),
      },

      {
        path: '/Activity/Module_circle', //模块管理
        name: '/Module_circle.vue',
        meta: { title: '圈子管理', keepAlive: false },
        component: () => import('../views/Activity/Module_circle.vue'),
      },
      {
        path: '/Activity/Activity_communication', //模块管理
        name: '/Activity_communication.vue',
        meta: { title: '活动交流', keepAlive: true },
        component: () => import('../views/Activity/Activity_communication.vue'),
      },
      {
        path: '/Activity/Activity_post', //模块管理
        name: '/Activity_post.vue',
        meta: { title: '帖子管理', keepAlive: true },
        component: () => import('../views/Activity/Activity_post.vue'),
      },

      {
        path: '/Activity/Project', //活动立项
        name: '/Project.vue',
        meta: { title: '活动立项', keepAlive: true },
        component: () => import('../views/Activity/Project.vue'),
      },

      {
        path: '/Activity/Labor_statistics',
        name: '/Labor_statistics.vue',
        meta: { title: '活动劳务统计', keepAlive: true },
        component: () => import('../views/Activity/Labor_statistics.vue'),
      }, 


      {
        path: '/Activity/Module_management', //模块管理
        name: '/Module_management.vue',
        meta: { title: '模块管理', keepAlive: true },
        component: () => import('../views/Activity/Module_management.vue'),
      },

      {
        path: '/Activity/Review_review',
        name: '/Review_review.vue',
        meta: { title: '评论审核', keepAlive: false },
        component: () => import('../views/Activity/Review_review.vue'),
      },

      {
        path: '/Activity/Activity_released', //系统设置
        name: 'Activity_released.vue',
        meta: { title: '活动发布', keepAlive: true },
        component: () => import('../views/Activity/Activity_released.vue'),
      },
      {
        path: '/Activity/Activity_offline', //系统设置
        name: 'Activity_offline.vue',
        meta: { title: '线下活动', keepAlive: true },
        component: () => import('../views/Activity/Activity_offline.vue'),
      },
      {
        path: '/Activity/Activity_selfhelp', //系统设置
        name: 'Activity_selfhelp.vue',
        meta: { title: '自助活动', keepAlive: true },
        component: () => import('../views/Activity/Activity_selfhelp.vue'),
      },

      {
        path: '/Activity/ExamineActivity', //活动审批
        name: '/ExamineActivity.vue',
        meta: { title: '活动审批', keepAlive: true },
        component: () => import('../views/Activity/ExamineActivity.vue'),
      },

      {
        path: '/Activity/ExamineInvitation', //活动审批
        name: '/ExamineInvitation.vue',
        meta: { title: '帖子审核', keepAlive: true },
        component: () => import('../views/Activity/ExamineInvitation.vue'),
      },

      {
        path: '/Activity/Activity_Profile', //系统设置
        name: 'Activity_Profile.vue',
        meta: { title: '活动情况', keepAlive: false },
        component: () => import('../views/Activity/Activity_Profile.vue'),
      },


      {
        path: '/Activity/index_ssscopy', //系统设置
        name: 'index_ssscopy.vue',
        meta: { title: 'ces', keepAlive: false },
        component: () => import('../views/Activity/index_ssscopy.vue'),
      },

      {
        path: '/Activity/Activity_Details_self', //活动管理
        name: 'Activity_Details_self.vue',
        meta: { title: '活动详情-自助', keepAlive: false },
        component: () => import('../views/Activity/Activity_Details_self.vue'),
      },

      {
        path: '/Activity/Activity_Details', //活动管理
        name: 'Activity_Details.vue',
        meta: { title: '活动详情-线下', keepAlive: false },
        component: () => import('../views/Activity/Activity_Details.vue'),
      },

      {
        path: '/Activity/Module_circle_details', //活动管理
        name: 'Module_circle_details.vue',
        meta: { title: '圈子详情', keepAlive: false },
        component: () => import('../views/Activity/Module_circle_details.vue'),
      },

      {
        path: '/Client/EmphasisClarification', //重点澄清
        name: 'EmphasisClarification.vue',
        meta: { title: '普测详情', keepAlive: true },
        component: () => import('../views/Client/EmphasisClarification.vue'),
      },
      {
        path: '/Client/HEmphasisClarification', //重点澄清
        name: 'HEmphasisClarification.vue',
        meta: { title: '联合预警', keepAlive: false },
        component: () => import('../views/Client/HEmphasisClarification.vue'),
      },
      
      {
        path: '/Client/PuceReport', //重点澄清
        name: 'PuceReport.vue',
        meta: { title: '普测整体报告', keepAlive: true },
        component: () => import('../views/Client/PuceReport.vue'),
      },
      //#region表单页面相关路由
      //开始--------表单页面相关路由
      {
        path: '/FormData/FDUserMng', //重点澄清
        name: 'FDUserMng',
        meta: { title: '上报人员管理', keepAlive: false },
        component: () => import('../views/FormData/FDUserMng.vue'),
      },
      {
        path: '/FormData/FDDataMng', //重点澄清
        name: 'FDDataMng',
        meta: { title: '上报数据管理', keepAlive: false },
        component: () => import('../views/FormData/FDDataMng.vue'),
      },
      {
        path: '/Education/coursemanagement', //课程管理
        name: 'coursemanagement',
        meta: { title: '课程管理', keepAlive: true },
        component: () => import('../views/Education/coursemanagement.vue'),
      },

      {
        path: '/Education/Expert_management', //课程管理
        name: 'Expert_management',
        meta: { title: '专家管理', keepAlive: true },
        component: () => import('../views/Education/Expert_management.vue'),
      },

      {
        path: '/Education/addcourse', //新增课程
        name: 'addcourse',
        meta: { title: '新增课程' , keepAlive: true},
        component: () => import('../views/Education/addcourse.vue'),
      },
      {
        path: '/Education/addtestpaper', //添加试卷
        name: 'addtestpaper',
        meta: { title: '添加试卷', keepAlive: true },
        component: () => import('../views/Education/addtestpaper.vue'),
      },
      {
        path: '/Education/Offline_training', //线下培训
        name: 'Offline_training',
        meta: { title: '线下培训', keepAlive: false },
        component: () => import('../views/Education/Offline_training.vue'),
      },
      {
        path: '/Education/trainingmanagement', //培训管理
        name: 'trainingmanagement',
        meta: { title: '培训管理', keepAlive: true },
        component: () => import('../views/Education/trainingmanagement.vue'),
      }, {
        path: '/Education/trainingrelease', //培训详情
        name: 'trainingrelease',
        meta: { title: '培训添加修改', keepAlive: true },
        component: () => import('../views/Education/trainingrelease.vue'),
      }, {
        path: '/Education/trainingstatistics', //培训统计
        name: 'trainingstatistics',
        meta: { title: '培训统计', keepAlive: true },
        component: () => import('../views/Education/trainingstatistics.vue'),
      }, {
        path: '/Education/learningstatistics', //学习统计
        name: 'learningstatistics',
        meta: { title: '学习统计', keepAlive: false },
        component: () => import('../views/Education/learningstatistics.vue'),
      }, {
        path: '/Education/Examstatistics', //考试统计
        name: 'Examstatistics',
        meta: { title: '考试统计', keepAlive: true },
        component: () => import('../views/Education/Examstatistics.vue'),
      }, {
        path: '/Education/examlist', //考试列表
        name: 'examlist',
        meta: { title: '考试列表', keepAlive: false },
        component: () => import('../views/Education/examlist.vue'),
      }, {
        path: '/Education/exammanage', //试卷管理
        name: 'exammanage',
        meta: { title: '试卷管理', keepAlive: true },
        component: () => import('../views/Education/exammanage.vue'),
      }, {
        path: '/Education/scoredetail', //试卷详情
        name: 'scoredetail',
        meta: { title: '得分详情', keepAlive: false },
        component: () => import('../views/Education/scoredetail.vue'),
      }, {
        path: '/Education/papergrad', //试卷详情
        name: 'papergrad',
        meta: { title: '试卷批阅', keepAlive: false },
        component: () => import('../views/Education/papergrad.vue'),
      }, {
        path: '/Education/activestatistics', //活跃统计
        name: 'activestatistics',
        meta: { title: '活跃统计', keepAlive: true },
        component: () => import('../views/Education/activestatistics.vue'),
      }, {
        path: '/Education/courseDetail', //课程详情
        name: 'courseDetail',
        meta: { title: '课程详情', keepAlive: false },
        component: () => import('../views/Education/courseDetail.vue'),
      }, {
        path: '/Education/coursequestionbank', //课程题库
        name: 'coursequestionbank',
        meta: { title: '考题管理', keepAlive: true },
        component: () => import('../views/Education/coursequestionbank.vue'),
      }, {
        path: '/Education/questionentry', //题目录入
        name: 'questionentry',
        meta: { title: '题目录入', keepAlive: false },
        component: () => import('../views/Education/questionentry.vue'),
      }, {
        path: '/Education/addquestion', //添加单选题
        name: 'addquestion',
        meta: { title: '添加单选题', keepAlive: false },
        component: () => import('../views/Education/addquestion.vue'),
      }, {// 知识图谱
        path: '/knowledgegraph/Industryknowledge', //行业知识
        name: 'Industryknowledge',
        meta: { title: '行业知识', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/Industryknowledge.vue'),
      }, {
        path: '/knowledgegraph/AddNode', //行业知识
        name: 'AddNode',
        meta: { title: '添加节点', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/AddNode.vue'),
      }, {
        path: '/knowledgegraph/AddRelationship', //行业知识
        name: 'AddRelationship',
        meta: { title: '添加关系', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/AddRelationship.vue'),
      }, {
        path: '/knowledgegraph/userAddNode', //行业知识
        name: 'userAddNode',
        meta: { title: '添加用户节点', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/userAddNode.vue'),
      }, {
        path: '/knowledgegraph/userAddRelationship', //行业知识
        name: 'userAddRelationship',
        meta: { title: '添加用户关系', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/userAddRelationship.vue'),
      }, {
        path: '/knowledgegraph/MemberManagement', //行业知识
        name: 'MemberManagement',
        meta: { title: '会员管理', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/MemberManagement.vue'),
      }, {
        path: '/knowledgegraph/OrderManagement', //行业知识
        name: 'OrderManagement',
        meta: { title: '订单管理', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/OrderManagement.vue'),
      }, {
        path: '/knowledgegraph/Userportrait', //行业知识
        name: 'Userportrait',
        meta: { title: '用户画像', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/Userportrait.vue'),
      }, {
        path: '/knowledgegraph/ImageDetails', //行业知识
        name: 'ImageDetails',
        meta: { title: '画像详情', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/ImageDetails.vue'),
      }, {
        path: '/knowledgegraph/UserRelations', //行业知识
        name: 'UserRelations',
        meta: { title: '用户关系', keepAlive: false },
        component: () => import('../views/Data/knowledgegraph/UserRelations.vue'),
      }, {
        path: '/psychometrics/comprehensiveconditions', //心理测评
        name: 'comprehensiveconditions',
        meta: { title: '综合条件配置', keepAlive: false },
        component: () => import('../views/psychometrics/comprehensiveconditions.vue'),
      }, {
        path: '/psychometrics/Packageconfiguration', //心理测评
        name: 'Packageconfiguration',
        meta: { title: '套餐配置', keepAlive: false },
        component: () => import('../views/psychometrics/Packageconfiguration.vue'),
      }, {
        path: '/psychometrics/Testquery', //心理测评
        name: 'Testquery',
        meta: { title: '测试查询统计', keepAlive: false },
        component: () => import('../views/psychometrics/Testquery.vue'),
      }, {
        path: '/psychometrics/crisisearlywarn', //心理测评
        name: 'crisisearlywarn',
        meta: { title: '危机预警查看', keepAlive: false },
        component: () => import('../views/psychometrics/crisisearlywarn.vue'),
      }, {
        path: '/psychometrics/Overall', //心理测评
        name: 'Overall',
        meta: { title: '总体情况查询', keepAlive: false },
        component: () => import('../views/psychometrics/Overall.vue'),
      }, {
        path: '/psychometrics/Addconditions',//心理测评
        name: 'Addconditions',
        meta: { title: '新增条件', keepAlive: false },
        component: () => import('../views/psychometrics/Addconditions.vue')
      },{
        path:'/CounselorLeave/Teleconsultation',//远程咨询
        name:'Teleconsultation',
        meta: { title: '远程咨询', keepAlive: false },
        component:()=> import('../views/CounselorLeave/Teleconsultation.vue')
      },


      {
        path: '/statement/Basic_content',
        name: '/Basic_content.vue',
        meta: { title: '基本内容配置', keepAlive: false },
        component: () => import('../views/statement/Basic_content.vue'),
      },
      {
        path: '/statement/Chart',
        name: '/Chart.vue',
        meta: { title: '图表配置', keepAlive: false },
        component: () => import('../views/statement/Chart.vue'),
      },
      {
        path: '/statement/Chart_add',
        name: '/Chart_add.vue',
        meta: { title: '图表配置添加', keepAlive: false },
        component: () => import('../views/statement/Chart_add.vue'),
      },

      {
        path: '/statement/Scale_configuration',
        name: '/Scale_configuration.vue',
        meta: { title: '图表刻度配置', keepAlive: false },
        component: () => import('../views/statement/Scale_configuration.vue'),
      },

      {
        path: '/statement/Scale_configuration_add',
        name: '/Scale_configuration_add.vue',
        meta: { title: '图表刻度配置添加', keepAlive: false },
        component: () => import('../views/statement/Scale_configuration_add.vue'),
      },{
        path: '/statement/argument',
        name: '/argument.vue',
        meta: { title: '格式参数配置', keepAlive: false },
        component: () => import('../views/statement/argument.vue'),
      },{
        path: '/ChatGPT/Facerecognition', //人脸识别
        name: 'Facerecognition',
        meta: { title: 'chatgpt', keepAlive: false },
        component: () => import('../views/ChatGPT/Facerecognition.vue'),
      },{
        path: '/Analysissoftware/analyzing', //呼吸解析
        name: 'analyzing',
        meta: { title: '呼吸解析', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/analyzing.vue'),
      },{
        path: '/Analysissoftware/HRV', //HRV
        name: 'HRV',
        meta: { title: 'HRV', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/HRV.vue'),
      },{
        path: '/Analysissoftware/eeg', //脑电
        name: 'eeg',
        meta: { title: '脑电', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/eeg.vue'),
      },{
        path: '/Analysissoftware/electromechanical', //肌电解析
        name: 'electromechanical',
        meta: { title: '肌电解析', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/electromechanical.vue'),
      },{
        path: '/Analysissoftware/Bloodoxygen', //血氧解析
        name: 'Bloodoxygen',
        meta: { title: '血氧解析', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/Bloodoxygen.vue'),
      },{
        path: '/Analysissoftware/skintemperature', //皮温解析
        name: 'skintemperature',
        meta: { title: '皮温解析', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/skintemperature.vue'),
      },{
        path: '/Analysissoftware/GSR', //皮电解析
        name: 'AnalysissoftwareGSR',
        meta: { title: '皮电解析', keepAlive: false },
        component: () => import('../views/Data/Analysissoftware/GSR.vue'),
      },{
        path: '/biofeedback/release', //生物反馈发布
        name: 'biofeedbackrelease',
        meta: { title: '生物反馈发布', keepAlive: false },
        component: () => import('../views/biofeedback/release.vue'),
      },{
        path: '/biofeedback/biofeedbacklsit', //生物反馈列表
        name: 'biofeedbacklsit',
        meta: { title: '生物反馈', keepAlive: false },
        component: () => import('../views/biofeedback/biofeedbacklsit.vue'),
      },{
        path: '/biofeedback/reportlist', //生物反馈报告列表
        name: 'reportlist',
        meta: { title: '生物反馈报告', keepAlive: false },
        component: () => import('../views/biofeedback/reportlist.vue'),
      },{
        path: '/biofeedback/Relaxation_pod', //放松舱监控
        name: 'Relaxation_pod',
        meta: { title: '放松舱监控', keepAlive: false },
        component: () => import('../views/biofeedback/Relaxation_pod.vue'),
      },{
        path: '/digitalize/MemberList', //会员列表
        name: 'MemberList',
        meta: { title: '会员列表', keepAlive: false },
        component: () => import('../views/Data/digitalize/MemberList.vue'),
      },{
        path: '/digitalize/Membershippackage', //会员套餐
        name: 'Membershippackage',
        meta: { title: '会员套餐', keepAlive: false },
        component: () => import('../views/Data/digitalize/Membershippackage.vue'),
      },{
        path: '/digitalize/institution', //机构主页
        name: 'institution',
        meta: { title: '机构主页', keepAlive: false },
        component: () => import('../views/Data/digitalize/institution.vue'),
      },{
        path: '/digitalize/Appointmentallocation', //个案分配
        name: 'Appointmentallocation',
        meta: { title: '个案分配', keepAlive: false },
        component: () => import('../views/Data/digitalize/Appointmentallocation.vue'),
      },{
        path: '/digitalize/PlatformFinance', //平台财务
        name: 'PlatformFinance',
        meta: { title: '平台财务', keepAlive: false },
        component: () => import('../views/Data/digitalize/PlatformFinance.vue'),
      },{
        path: '/digitalize/customermanagement', //客户管理
        name: 'customermanagement',
        meta: { title: '客户管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/customermanagement.vue'),
      },{
        path: '/digitalize/contractmanagement', //合同管理
        name: 'contractmanagement',
        meta: { title: '合同管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/contractmanagement.vue'),
      },{
        path: '/digitalize/charge', //收费管理
        name: 'charge',
        meta: { title: '收费管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/charge.vue'),
      },{
        path: '/digitalize/qualitysupervision', //质量监督
        name: 'qualitysupervision',
        meta: { title: '质量监督', keepAlive: false },
        component: () => import('../views/Data/digitalize/qualitysupervision.vue'),
      },{
        path: '/digitalize/performancemanagement', //绩效管理
        name: 'performancemanagement',
        meta: { title: '绩效管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/performancemanagement.vue'),
      },{
        path: '/digitalize/institutionalaccreditation', //机构认证
        name: 'institutionalaccreditation',
        meta: { title: '机构认证', keepAlive: false },
        component: () => import('../views/Data/digitalize/institutionalaccreditation.vue'),
      },{
        path: '/digitalize/institutionList', //机构列表
        name: 'institutionList',
        meta: { title: '机构列表', keepAlive: false },
        component: () => import('../views/Data/digitalize/institutionList.vue'),
      },
      {
        path: '/digitalize/returnvisit', //回访管理
        name: 'returnvisit',
        meta: { title: '回访管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/returnvisit.vue'),
      },
      {
        path: '/digitalize/appeal', //回访管理
        name: 'appeal',
        meta: { title: '服务诉求', keepAlive: false },
        component: () => import('../views/Data/digitalize/appeal.vue'),
      },
      {
        path: '/ChatGPT/transcribe', //录制
        name: 'transcribe',
        meta: { title: '录制', keepAlive: false },
        component: () => import('../views/ChatGPT/transcribe.vue'),
      },{
        path: '/digitalize/OrderManagement',
        name: 'OrderManagement',
        meta: { title: '测评订单管理', keepAlive: false },
        component: () => import('../views/Data/digitalize/OrderManagement.vue'),
      },{
        path: '/digitalize/Intelligentmatching',
        name: 'Intelligentmatching',
        meta: { title: '智能匹配规则配置', keepAlive: false },
        component: () => import('../views/Data/digitalize/Intelligentmatching.vue'),
      },{
        path: '/digitalize/Groupclients',
        name: 'Groupclients',
        meta: { title: '团体客户', keepAlive: false },
        component: () => import('../views/Data/digitalize/Groupclients.vue'),
      },{
        path:'/psychometrics/Personalprofile',
        name: 'Personalprofile',
        meta: { title: '个人档案', keepAlive: false },
        component: () => import('../views/psychometrics/Personalprofile.vue'),
      },{
        path:'/digitalize/Teamarchives',
        name: 'Teamarchives',
        meta: { title: '团建档案', keepAlive: false },
        component: () => import('../views/Data/digitalize/Teamarchives.vue'),
      },{
        path:'/training/PublishPackage',
        name: 'Teamarchives',
        meta: { title: '发布套餐', keepAlive: false },
        component: () => import('../views/training/PublishPackage.vue'),
      },{
        path:'/digitalize/Logexception',
        name: 'Logexception',
        meta: { title: '日志异常', keepAlive: false },
        component: () => import('../views/Data/digitalize/Logexception.vue'),
      },{
        path:'/digitalize/Consultantcertification',
        name: 'Consultantcertification',
        meta: { title: '咨询师审批', keepAlive: false },
        component: () => import('../views/Data/digitalize/Consultantcertification.vue'),
      }



      //结束--------表单页面相关路由
      //#endregion
    ],
  },{
    path: '/training/GameReport',
    name: 'GameReport',
    meta: { title: '游戏报告', keepAlive: false },
    component: () => import('../views/training/GameReport.vue'),
  },
  {
    path: '/psychometrics/Overallarchivereport',
    name: 'Overallarchivereport',
    meta: { title: '整体档案报告', keepAlive: false },
    component: () => import('../views/psychometrics/Overallarchivereport.vue'),
  },{
    path: '/ChatGPT/ChatPage', //CHATGPT问答ai页面
    name: 'ChatPage',
    meta: { title: 'chatgpt', keepAlive: false },
    component: () => import('../views/ChatGPT/ChatPage.vue'),
  }, 
  {
    path: '/ClientLogin',
    name: 'ClientLogin',
    component: () => import('../views/Client/ClientLogin.vue'),
  },
  {
    path: '/Client/ClientIndex',
    name: 'Client',
    meta: { title: '主页' },
    component: () => import('../views/Client/ClientIndex.vue'),
    children: [
      {
        path: '/Client/Home', //首页
        name: 'Home',
        meta: { title: '首页' },
        component: () => import('../views/Client/Home.vue'),
      },
      {
        path: '/Client/Clienttest',
        name: 'Clienttest',
        component: () => import('../views/Client/Clienttest.vue'), //Clienttest
      },
      {
        path: '/Client/Waiting_test',
        name: '/Waiting_test',
        meta: { title: '来访者测试', keepAlive: false },
        component: () => import('../views/Client/Waiting_test.vue'),
      },
      {
        path: '/Client/ClientConsulting', //首页
        name: 'ClientConsulting',
        meta: { title: '咨询', keepAlive: false},
        component: () => import('../views/Client/ClientConsulting.vue'), //咨询
      },

      {
        path: '/Client/PaperTest', //首页
        name: 'PaperTest1',
        meta: { title: '咨询', keepAlive: false },
        component: () => import('../views/Client/PaperTest.vue'), //咨询
      },
    ],
  },
  {
    path: '/RPLogin',
    name: 'RPLogin',
    component: () => import('../views/ReportData/RPLogin.vue'),
  },
  {
    path: '/ReportData/RPIndex',
    name: 'ReportData',
    meta: { title: '首页' },
    component: () => import('../views/ReportData/RPIndex.vue'),
    children: [
      {
        path: '/ReportData/RPHome',
        name: 'RPHome',
        meta: { title: '首页' },
        component: () => import('../views/ReportData/RPHome.vue'),
      },
      {
        path: '/ReportData/RPUserList',
        name: 'RPUserList',
        meta: { title: '对象列表', keepAlive: false },
        component: () => import('../views/ReportData/RPUserList.vue'),
      },
      {
        path: '/ReportData/RPUserSetting',
        name: 'RPUserSetting',
        meta: { title: '访谈人员分配', keepAlive: false },
        component: () => import('../views/ReportData/RPUserSetting.vue'),
      },
      {
        path: '/ReportData/RPDataReportMaster',
        name: 'RPDataReportMaster',
        meta: { title: '数据上报', keepAlive: false },
        component: () => import('../views/ReportData/RPDataReportMaster.vue'),
      },
      {
        path: '/ReportData/RPConsultUserList',
        name: 'RPConsultUserList',
        meta: { title: '访谈者评估', keepAlive: false },
        component: () => import('../views/ReportData/RPConsultUserList.vue'),
      },
    ],
  },
  {
    path: '/ReportData/RPStatistics',
    name: 'RPStatistics',
    meta: { title: '数据统计', keepAlive: false },
    component: () => import('../views/ReportData/RPStatistics.vue'),
  },
  {
    path: '/ReportData/RPIndexOther',
    name: 'RPIndexOther',
    meta: { title: '首页' },
    component: () => import('../views/ReportData/RPIndexOther.vue'),
    children: [
      {
        path: '/ReportData/RPUser', //列表展示
        name: 'RPUser',
        meta: { title: '用户中心', keepAlive: false },
        component: () => import('../views/ReportData/RPUser.vue'),
      },
      {
        path: '/ReportData/RPUserAdd', //列表展示
        name: 'RPUserAdd',
        meta: { title: '用户添加', keepAlive: false },
        component: () => import('../views/ReportData/RPUserAdd.vue'),
      },
      {
        path: '/ReportData/PRDeparttMent', //列表展示
        name: 'PRDeparttMent',
        meta: { title: '部门管理', keepAlive: false },
        component: () => import('../views/ReportData/PRDeparttMent.vue'),
      },
    ],
  },{
    path: '/Game/cognitivetraining', //列表展示
    name: 'GamePRDeparttMent',
    meta: { title: '认知训练', keepAlive: false },
    component: () => import('../views/Game/cognitivetraining.vue'),
  },{
    path: '/biofeedback/report', //生物反馈报告
    name: 'wreports',
    meta: { title: '生物反馈报告', keepAlive: false },
    component: () => import('../views/biofeedback/report.vue'),
  }
];
const router = new VueRouter({
  mode: 'history',
  routes,
});
router.beforeEach(function (to, from, next) {
  if (to.path.indexOf('/Client') >= 0 || to.path == '/ClientLogin') {
    if (to.path != '/ClientLogin' && to.path != '/Client') {
      if (to.name != '/client/ClientLogin' && !from.name && sessionStorage.getItem('Authorization') == null) {
        next('/client/ClientLogin');
      } else if (from.name != 'ClientLogin' && Number(new Date().getTime()) >= 6000000 + Number(sessionStorage.getItem('sdtime'))) {
        if (to.path !== '/client/ClientLogin') {
          localStorage.clear();
          sessionStorage.clear();
          next('/client/ClientLogin');
        }
      } else {
        sessionStorage.setItem('sdtime', new Date().getTime());
      }
    }
  } else {
    if (to.path != '/Visitors/ReportShowApp') {
      if (to.name != 'login' && !from.name && sessionStorage.getItem('Authorization') == null) {
        if (to.name != 'LoginTransfer') {
          next('/login');
        }
      } else if (from.name != 'login' && Number(new Date().getTime()) >= 6000000 + Number(sessionStorage.getItem('sdtime')) && !sessionStorage.getItem('Authorization')) {
        if (to.path !== '/login') {
          localStorage.clear();
          sessionStorage.clear();
          next('/login');
        }
      } else {
        sessionStorage.setItem('sdtime', new Date().getTime());
        if (to.name != 'login' && (localStorage.getItem('userInfo') == undefined || localStorage.getItem('userInfo') == null || localStorage.getItem('userInfo') == '')) {
          next('/login');
        }
      }
    }
  }
  next();
});


export default router;
